module.exports = __webpack_public_path__ + "static/media/wordtune_ai.e73788bb.png";